export default {
  atualizarErrorAba({ commit }, _payload) {
    // IDs validos para as abas
    const abasIds = [
      "dadosCadastrais",
      "infraestrutura",
      "diretorTecnico",
      "servicos",
      "transplantes",
      "atendimento",
      "servicosPrestados",
      "especialidadesServicosPrestados",
      "dadosUnidadeAps"
    ];

    const checkMatch = abasIds.find(id => id === _payload.abaId);

    if (!checkMatch)
      throw new Error("id da aba é invalido. cheque os ids validos");

    const payload = { abaId: checkMatch, temError: _payload.temError };

    commit("setErrorAba", payload);
  },
  // Retorna a mensagem a ser mostrada no modal
  checarErrorsNasAbas({ commit, getters }) {
    const abasComErrors = getters.getAbasComErrors;

    if (abasComErrors.length > 0) {
      commit("setMostrarErrors", true);
    } else {
      commit("setMostrarErrors", false);
    }

    return getters.getMenssagemErrorModal;
  }
};
